import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import SvgIcon from '../common/SvgIcon';

class Panel extends React.Component {
  constructor(props) {
    super(props);
    this.getPanel = this.getPanel(this);
  }

  getPanel() {
    const panelObject = [];
    let panelItem;
    if (this.props.panelHeading.length > 0 && this.props.panelBody.length > 0) {
      _.zipWith(
        this.props.panelHeading,
        this.props.panelBody,
        this.props.iconClass,
        (heading, body, icon) => {
          panelItem = (
            <div className="c-panel c-panel--help-page">
              <h3 className="c-panel__heading">
                <div className="c-panel__icons">
                  <SvgIcon id={icon} width="16px" height="16px" />
                </div>
                {heading}
              </h3>
              <div className="c-panel__body">
                <div>{body}</div>
              </div>
            </div>
          );
          panelObject.push(panelItem);
        }
      );
    }
    return panelObject;
  }

  render() {
    return <div>{this.getPanel}</div>;
  }
}

Panel.propTypes = {
  panelHeading: PropTypes.array,
  panelBody: PropTypes.array,
  iconClass: PropTypes.array,
};
Panel.defaultProps = {
  panelHeading: ['Heading 1', 'Heading 2'],
  panelBody: [
    'Jura donec turpis justo, tristique ac ferm entum quis, cursur non diam auris velerti porta manga.',
    'Jura donec turpis justo, tristique ac ferm entum quis, cursur non diam auris velerti porta manga.',
  ],
  iconClass: [
    'c-panel__icon icon-help-questions',
    'c-panel__icon icon-chat',
    'c-panel__icon icon-telephone',
    'c-panel__icon icon-help-reminders',
    'c-panel__icon icon-case',
    'c-panel__icon icon-fscs',
  ],
};

export default Panel;
